export default __webpack_public_path__ + "static/media/somethingWrong.a5c46176.svg";